module.exports = __webpack_public_path__ + "static/img/innovative.67cc66e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/innovative.png
// module id = IpK0
// module chunks = 0